import React from "react";
import { ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SectionCategoryCardProps {
  category: {
    name: string;
    description: string;
    icon: string;
    color: string;
  };
  onClick: () => void;
}

const getIconElement = (iconName: string) => {
  // Map icon names to their corresponding symbols or elements
  const iconMap: Record<string, string> = {
    heroicon: "🦸",
    navigation: "🧭",
    cta: "🎯",
    footer: "🦶",
    header: "📄",
    content: "📝",
    gallery: "🖼️",
    testimonial: "💬",
    contact: "📞",
    pricing: "💰",
    feature: "⭐",
    blog: "📰",
    team: "👥",
    about: "ℹ️",
    product: "🛍️",
    service: "🔧",
    portfolio: "💼",
    faq: "❓",
    social: "📱",
    video: "🎥",
    image: "🖼️",
    text: "📝",
    button: "🔘",
    form: "📋",
    map: "🗺️",
    calendar: "📅",
    chart: "📊",
    table: "📊",
    card: "🃏",
    list: "📄",
    divider: "➖",
    spacer: "⬜",
    other: "📦",
  };

  return iconMap[iconName.toLowerCase()] || iconMap["other"] || "📦";
};

export function SectionCategoryCard({
  category,
  onClick,
}: SectionCategoryCardProps) {
  const iconElement = getIconElement(category.icon);

  return (
    <Button
      variant="section"
      size="section"
      onClick={onClick}
      style={{
        boxShadow: `inset 0 0 0 2px ${category.color}20`,
      }}
    >
      {/* Color indicator */}
      <div
        className="absolute top-1 right-1 w-2 h-2 rounded-full opacity-70"
        style={{ backgroundColor: category.color }}
      />

      {/* Icon */}
      <div className="text-lg mb-1">{iconElement}</div>

      {/* Name */}
      <span className="text-xs font-medium text-center w-full break-words line-clamp-2">
        {category.name}
      </span>

      {/* Description hint */}
      <span className="text-xs text-muted-foreground group-hover:text-primary-foreground/70 text-center w-full break-words line-clamp-1">
        {category.description}
      </span>

      <ChevronRight className="w-3 h-3" />
    </Button>
  );
}
